
/**
 * 展开闭合器
 */
export default {
  props: {
    openHeight: { type: Number, default: 200 },
    closeHeight: { type: Number, default: 50 },
  },
  data(): any {
    return {
      expended: false,
    };
  },
};
